import { VdsSidenavItemCategory } from '@volt/volt-extended-components-react';
import styles from './SideNavMenu.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@casops/store/hooks';
import { isNavCategory, mainNavigation, NavCategory, NavLinkData } from '@casops/navigation';
import { ReactElement, useMemo } from 'react';
import SideNavLinks from '../side-nav-links/SideNavLinks';
import { userHasPermission } from '@casops/permissions';
import SideNavLink from '../side-nav-link/SideNavLink';

interface SideNavMenuProps {
  isOpen: boolean;
}

export function SideNavMenu({ isOpen }: SideNavMenuProps): ReactElement {
  const { t } = useTranslation();

  const userData = useAppSelector(state => state.auth);

  const permittedNavItems = useMemo<(NavCategory | NavLinkData)[]>(
    () => mainNavigation.filter(({ permission }) => userHasPermission(userData, permission)),
    [userData],
  );

  return (
    <div className={styles.mainMenu}>
      {permittedNavItems.map(navItem => {
        if (isNavCategory(navItem)) {
          return (
            <VdsSidenavItemCategory
              key={navItem.key}
              expanded={isOpen}
              isStatic={false}
              value={t(navItem.transKey)}
            >
              <div slot="category-items">
                <SideNavLinks isOpen={isOpen} links={navItem.links} />
              </div>
            </VdsSidenavItemCategory>
          );
        } else {
          return <SideNavLink key={navItem.key} linkData={navItem} isOpen={isOpen} />;
        }
      })}
    </div>
  );
}

export default SideNavMenu;
